import { PAYMENT_ENDPOINTS } from '@/config/api';
import { httpClient } from '@/lib/http-client';
import type {
  CreatePaymentRequest,
  CustomerPaymentOptions,
  MethodsList,
  Payment,
  PaymentMethod,
  PaymentResult,
} from '@/types/payment';

export class PaymentsApi {
  static getPaymentOptions(): Promise<CustomerPaymentOptions> {
    return httpClient.get<CustomerPaymentOptions>(PAYMENT_ENDPOINTS.PAYMENT_OPTIONS);
  }

  static createPayment(data: CreatePaymentRequest): Promise<PaymentResult> {
    return httpClient.post<PaymentResult, CreatePaymentRequest>(
      PAYMENT_ENDPOINTS.PAYMENTS,
      data,
    );
  }

  static getPayment(paymentId: string): Promise<Payment> {
    return httpClient.get<Payment>(PAYMENT_ENDPOINTS.PAYMENT_BY_ID(paymentId));
  }

  static getVaultMethods(): Promise<MethodsList> {
    return httpClient.get<MethodsList>(PAYMENT_ENDPOINTS.VAULT);
  }

  static getVaultMethod(methodId: string): Promise<PaymentMethod> {
    return httpClient.get<PaymentMethod>(PAYMENT_ENDPOINTS.VAULT_METHOD_BY_ID(methodId));
  }

  static deleteVaultMethod(methodId: string): Promise<void> {
    return httpClient.delete<void>(PAYMENT_ENDPOINTS.VAULT_METHOD_BY_ID(methodId));
  }

  static setDefaultVaultMethod(methodId: string): Promise<PaymentMethod> {
    return httpClient.put<PaymentMethod>(PAYMENT_ENDPOINTS.VAULT_METHOD_DEFAULT(methodId));
  }
}

export function buildPaymentReturnUrl(): string {
  return `${window.location.origin}/payments`;
}
